import { loanPurposeTypes, propertyUsageTypes } from "./constants";
export var CreditScoreValues = [{
  id: 741,
  name: "740+"
}, {
  id: 730,
  name: "720-739"
}, {
  id: 710,
  name: "700-719"
}, {
  id: 690,
  name: "680-699"
}, {
  id: 670,
  name: "660-679"
}, {
  id: 650,
  name: "640-659"
}, {
  id: 630,
  name: "620-639"
}];
export var LoanPurpose = [{
  id: loanPurposeTypes.PURCHASE,
  name: "Purchase",
  numericId: 1
}, {
  id: loanPurposeTypes.REFINANCE_CASH_OUT,
  name: "Refinance Cash Out",
  numericId: 2
}, {
  id: loanPurposeTypes.REFINANCE_RATE_TERM_LIMITED,
  name: "Refinance",
  numericId: 3
}];
export var PropertyUsageType = [{
  id: propertyUsageTypes.INVESTMENT_PROPERTY,
  name: "Investment Property",
  numericId: 1
}, {
  id: propertyUsageTypes.PRIMARY_RESIDENCE,
  name: "Primary Residence",
  numericId: 2
}, {
  id: propertyUsageTypes.SECOND_HOME,
  name: "Second Home",
  numericId: 3
}];
export var PropertyType = [{
  id: "Condo",
  name: "Condo",
  numericId: 1
}, {
  id: "SingleFamily",
  name: "Single Family",
  numericId: 2
}, {
  id: "Townhouse",
  name: "Townhouse",
  numericId: 3
}];
export var VeteranType = [{
  id: "ActiveDuty",
  name: "Active Duty",
  numericId: 1
}, {
  id: "NationalGuardOrReserves",
  name: "National Guard or Reserves",
  numericId: 2
}];
export var DROPDOWN_IDS = {
  STATE: "State",
  CREDIT_SCORE: "CreditScore",
  LOAN_PURPOSE: "LoanPurpose",
  LOAN_PRODUCT: "LoanProduct",
  PROPERTY_TYPE: "PropertyType",
  USAGE_TYPE: "PropertyUsageType",
  COUNTY: "County",
  LOAN_TERM: "LoanTerm",
  VETERAN_TYPE: "VeteranType"
};
export var DropdownValues = [{
  id: DROPDOWN_IDS.LOAN_PURPOSE,
  name: "Loan Purpose",
  data: LoanPurpose
}, {
  id: DROPDOWN_IDS.USAGE_TYPE,
  name: "Usage Type",
  data: PropertyUsageType
}, {
  id: DROPDOWN_IDS.PROPERTY_TYPE,
  name: "Property Type",
  data: PropertyType
}, {
  id: DROPDOWN_IDS.STATE,
  name: "State",
  data: []
}, {
  id: DROPDOWN_IDS.COUNTY,
  name: "County",
  data: []
}, {
  id: DROPDOWN_IDS.CREDIT_SCORE,
  name: "Credit Score",
  data: CreditScoreValues
}, {
  id: DROPDOWN_IDS.VETERAN_TYPE,
  name: "Veteran Type",
  data: VeteranType
}];